import { createAppSelector } from '~/store/utils/createSelector';
import { POSHTA_MARKER_STATUS } from '~/types/poshta';

import type { RootState } from '~/store';
import type { POSHTA_MARKER_NAME, POSHTA_MARKER_SOURCE, PoshtaMarker } from '~/types/poshta';

export const isPoshtaReadySelector = (state: RootState) => state.poshta.isReady;

const poshtaMarkersSelector = (state: RootState) => state.poshta.markers || [];

const poshtaMarkersActiveSelector = createAppSelector(poshtaMarkersSelector, (markers) =>
  markers.filter((m) => m.status === POSHTA_MARKER_STATUS.ACTIVE),
);

export const activePoshtaMarkersByItemsSelector = createAppSelector(
  [poshtaMarkersActiveSelector, (_, items: { name: POSHTA_MARKER_NAME; source: POSHTA_MARKER_SOURCE }[]) => items],
  (activeMarkers, items): PoshtaMarker[] => {
    if (items.length === 0) {
      return [];
    }

    const allowed = new Set(items.map((i) => `${i.name}::${i.source}`));
    return activeMarkers.filter((m) => allowed.has(`${m.name}::${m.source}`)) || [];
  },
);
